"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedDigestItemsResponseDto = instanceOfPaginatedDigestItemsResponseDto;
exports.PaginatedDigestItemsResponseDtoFromJSON = PaginatedDigestItemsResponseDtoFromJSON;
exports.PaginatedDigestItemsResponseDtoFromJSONTyped = PaginatedDigestItemsResponseDtoFromJSONTyped;
exports.PaginatedDigestItemsResponseDtoToJSON = PaginatedDigestItemsResponseDtoToJSON;
exports.PaginatedDigestItemsResponseDtoToJSONTyped = PaginatedDigestItemsResponseDtoToJSONTyped;
var DigestPaginationMetaDto_1 = require("./DigestPaginationMetaDto");
var DigestItemDto_1 = require("./DigestItemDto");
/**
 * Check if a given object implements the PaginatedDigestItemsResponseDto interface.
 */
function instanceOfPaginatedDigestItemsResponseDto(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedDigestItemsResponseDtoFromJSON(json) {
    return PaginatedDigestItemsResponseDtoFromJSONTyped(json, false);
}
function PaginatedDigestItemsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(DigestItemDto_1.DigestItemDtoFromJSON)),
        'meta': (0, DigestPaginationMetaDto_1.DigestPaginationMetaDtoFromJSON)(json['meta']),
    };
}
function PaginatedDigestItemsResponseDtoToJSON(json) {
    return PaginatedDigestItemsResponseDtoToJSONTyped(json, false);
}
function PaginatedDigestItemsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(DigestItemDto_1.DigestItemDtoToJSON)),
        'meta': (0, DigestPaginationMetaDto_1.DigestPaginationMetaDtoToJSON)(value['meta']),
    };
}
